import { trackButtonClicked } from '@heidi/analytics/events';
import { ButtonAction, ScreenName } from '@heidi/analytics/vocabulary';
import { Button } from '@heidi/design-system/button';
import { TypographyH5 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { useReverseTrial } from '../../data';
import { getCommerceBillingUiPorts } from '../settings/billing/billing-ui-ports';

interface PracticeTrialUpgradeBannerProps {
  onBeforeUpgrade?: () => void;
}

export function PracticeTrialUpgradeBanner({
  onBeforeUpgrade,
}: PracticeTrialUpgradeBannerProps) {
  const commerceBillingUiPorts = getCommerceBillingUiPorts();
  const { togglePracticeUpgradeModal } = commerceBillingUiPorts.usePaywallStates();
  const { trialDaysLeft } = useReverseTrial();
  const { t } = useTranslations();

  if (commerceBillingUiPorts.isAppleCompliantBuild()) {
    return null;
  }

  const handleUpgrade = () => {
    trackButtonClicked({
      screenName: ScreenName.TrialExtensionModal,
      action: ButtonAction.TrialExtensionUpgradeToPractice,
      label: 'Upgrade to Practice',
    });
    onBeforeUpgrade?.();
    togglePracticeUpgradeModal(true);
  };

  return (
    <div className="relative flex items-center justify-between overflow-hidden bg-tier-practice px-8 py-6">
      <div className="relative z-10 flex flex-col gap-0.5 text-text-primary-on-dark [.skiesTierDark_&]:text-text-primary-invert">
        <span className="font-exposure text-5xl font-semibold leading-none tracking-tight">
          {trialDaysLeft}
        </span>
        <span className="text-sm font-medium">{t('trialExtension.daysLeft')}</span>
      </div>

      {!commerceBillingUiPorts.isAppleCompliantBuild() && (
        <Button
          size="lg"
          variant="ghost"
          onClick={handleUpgrade}
          className="bg-background-primary px-4 py-3 text-text-primary-invert hover:bg-background-primary/100"
        >
          <TypographyH5>{t('trialExtension.upgradeNow')}</TypographyH5>
        </Button>
      )}
    </div>
  );
}
